import { accessTokenGenerate } from 'src/services/auth.service';
import Cookies from 'universal-cookie';

export function isLoggedInOrNot() {
  const cookies = new Cookies();

  const isLoggedIn = cookies.get('logged_in');
  const accessToken = cookies.get('access_token');
  const refreshToken = cookies.get('refresh_token');

  if (isLoggedIn) {
    if (accessToken) {
      return true;
    }
  } else if (refreshToken) {
    accessTokenGenerate();
    return true;
  } else {
    return false;
  }
}
